<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Sociometric Reports</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <sui-button primary content="How to conduct the sociogram" icon="question circle" v-on:click="openGallery(1)" />
      <sui-button primary content="How to extend a sociogram" icon="question circle" v-on:click="openGallery(2)" />
      <sui-button primary content="How to Use Generate Report Function" icon="question circle"
        v-on:click="openGallery(6)" />
    </div>
    <div class="ui message error" v-if="pagedTestsError">
      {{ pagedTestsError }}
    </div>
    <div class="row">
      <test-table v-bind:tests="pagedTests" v-bind:actions="actions" v-on:rowAction="rowAction" />
    </div>
    <div>
      <router-link to="/">
        <sui-button content="Back to home" positive icon="circle arrow left" />
      </router-link>
    </div>
    <div class="ui container center aligned">
      <sui-button v-if="hasPreviousPage" v-on:click="previousPage" content="Previous" />
      &nbsp;<span>Page: {{ this.paging.page }} of {{ this.totalPages }}</span>&nbsp;
      <sui-button v-if="hasNextPage" v-on:click="nextPage" content="Next" />
    </div>
  </div>
</template>

<script>
import TestTable from '@/components/tests/TestTable';
import StartTestForm from '@/components/tests/StartTestForm';
import { mapGetters } from 'vuex';

export default {
  name: 'TestSelection',
  components: { TestTable, StartTestForm },
  computed: {
    actions: {
      get() {
        // if (
        //   this.user.profile.role === 'Administrator' &&
        //   this.currentSchoolCode !== 'admin'
        // ) {
        //   return ['view'];
        // }
        return ['view', 'extend', 'remove'];
      },
    },
    ...mapGetters({
      pagedTests: 'pagedTests',
      pagedTestsError: 'pagedTestsError',
      paging: 'testsPaging',
      hasNextPage: 'testsHasNextPage',
      hasPreviousPage: 'testsHasPreviousPage',
      totalPages: 'testsTotalPages',
      currentSchoolCode: 'currentSchoolCode',
      user: 'user',
    }),
  },
  methods: {
    openGallery(index) {
      this.$store.dispatch('showImage', { index });
    },
    nextPage() {
      this.$store.dispatch('getPagedTests', {
        ...this.paging,
        page: this.paging.page + 1,
      });
    },
    previousPage() {
      this.$store.dispatch('getPagedTests', {
        ...this.paging,
        page: this.paging.page - 1,
      });
    },
    rowAction(action) {
      switch (action.action) {
        case 'remove':
          this.$dialog
            .confirm(
              'Are you sure you want to remove this sociogram and all its results?',
              {
                xt: 'Remove',
                cancelText: 'Cancel',
              },
            )
            .then(() => {
              this.$store.dispatch('removeTest', action.id).then(() => {
                this.$store.dispatch('getPagedTests', this.paging);
              });
            })
            .catch(() => { });
          break;
        case 'extend':
          // eslint-disable-next-line arrow-parens
          this.$store.dispatch(
            'setCurrentTest',
            // eslint-disable-next-line arrow-parens
            this.pagedTests.find((t) => t.id === action.id),
          );
          this.$store.dispatch('showExtendTestModal');
          break;
        default:
          this.$router.push(`/test/result/${action.id}`);
          break;
      }
    },
  },
  created() {
    this.$store.dispatch('getPagedTests', this.paging);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestSelection.vue